<template>
  <v-row>
    <v-col>
      <v-card class="mx-auto">
        <v-card-title
          class="white--text title body-1 pa-2"
          :style="`background-color: ${mainColor}`"
          dense
        >
          <v-icon dens left class="white--text">mdi-remote</v-icon>
          センサ一覧
          <v-spacer></v-spacer>
          <span class="caption">通知 オフ / オン</span>
        </v-card-title>
        <v-container fluid id="scroll-target" class="overflow-y-auto py-0">
          <v-row justify="center">
            <v-col cols="12">
              <v-list class="py-0">
                <v-list-item-group :color="mainColor">
                  <v-list-item
                    v-for="d in devicesOrderByIsSet"
                    :key="d.id"
                    dense
                    @click="setInfoDeviceId(d.id)"
                  >
                    <v-list-item-icon>
                      <v-icon :color="d.is_alert ? 'error' : 'success'">
                        {{ d.is_alert ? 'mdi-alert' : 'mdi-check-circle' }}
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        class="body-2"
                        v-text="d.name"
                      ></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-switch
                        class="my-0 py-0"
                        v-model="d.is_set"
                        @change="toggleUserDevice(d)"
                        @click.stop
                      ></v-switch>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { postUserDevice, deleteUserDevice } from '@/api'
import { MAIN_COLOR } from '@/constants'

export default {
  name: 'UserDeviceList',
  data() {
    return {
      mainColor: MAIN_COLOR
    }
  },
  computed: {
    ...mapGetters(['devicesOrderByIsSet'])
  },
  methods: {
    ...mapActions(['setInfoDeviceId', 'updateDeviceBy']),
    async toggleUserDevice(device) {
      try {
        if (device.is_set) {
          await postUserDevice(this.$route.params.provider, device.id)
        } else {
          await deleteUserDevice(this.$route.params.provider, device.id)
        }
      } catch (e) {
        console.error(e)
        alert('サーバエラーが発生しました。ログイン画面に遷移します。')
        this.$router.push('/auth/sign-out')
      }

      this.updateDeviceBy({
        id: device.id,
        key: 'is_set',
        value: device.is_set
      })
    }
  }
}
</script>
